export const headerTranslations = {
  pt: {
    home: "Home",
    qrCode: "Gerar QR Code grátis",
    documentGenerator: "Gerar CPF/CNPJ",
    documentValidator: "Validar CPF/CNPJ",
    login: "Entrar",
    signup: "Criar conta",
    switchLanguage: "Mudar para Inglês",
    openMenu: "Abrir menu",
    closeMenu: "Fechar menu"
  },
  en: {
    home: "Home",
    qrCode: "Free QR Code Generator",
    documentGenerator: "Generate CPF/CNPJ",
    documentValidator: "Validate CPF/CNPJ",
    login: "Login",
    signup: "Sign up",
    switchLanguage: "Switch to Portuguese",
    openMenu: "Open menu",
    closeMenu: "Close menu"
  }
};
